<div class="card-body">
    <div id="apex-custom-datalabels-bar"></div>
</div>